import type { ReactNode } from 'react';

interface FormStepShellProps {
  title: string;
  subtitle: string;
  children: ReactNode;
}

export const FormStepShell = ({ title, subtitle, children }: FormStepShellProps) => (
  <section className='space-y-6'>
    <div>
      <h2 className='text-2xl font-semibold tracking-tight text-slate-950'>{title}</h2>
      <p className='mt-2 text-sm text-slate-600'>{subtitle}</p>
    </div>
    {children}
  </section>
);
